module.exports = ".analysis-group{padding:auto}.analysis-group-separator{margin-top:4px;margin-bottom:4px;border-top:1px solid #34495e}";